import React from 'react';
import type { IRootStore } from './RootStore';
import { RootStore } from './RootStore';
import { bearerTokenProvider } from '@yakoffice/yakoffice-firebase';
import { BuildStore } from './Build/BuildStore';
import { BuildsApiGateway } from '../apiGateway/BuildsApiGateway';
import { ApiRequest } from '../apiGateway/ApiRequest';
import { BuildsStore } from './Build/BuildsStore';

export const rootStore = RootStore.create(
  {
    buildStore: BuildStore.create({ apiGateway: BuildsApiGateway.create({ apiRequest: ApiRequest.create() }) }),
    buildsStore: BuildsStore.create({ apiGateway: BuildsApiGateway.create({ apiRequest: ApiRequest.create() }) })
  },
  {
    bearerTokenProvider: bearerTokenProvider
  });

const RootStoreContext = React.createContext<IRootStore>(rootStore);

export const RootStoreProvider = RootStoreContext.Provider;
export const RootStoreConsumer = RootStoreContext.Consumer;

export default RootStoreContext;
